import { connect } from 'react-redux';
import { getTopBarbersData, getTopBarbersTotal } from '../selectors';
import PieChartWithLegend from '../../components/PieChartWithLegend';
import * as barberSelectors from '../../../barbers/selector';

const TopSalesByBarber = connect((state) => {
  const getBarberById = barberSelectors.getById.bind(null, state);
  return {
    title: 'Top sales by barber - Top 5',
    data: getTopBarbersData(state, getBarberById),
    total: getTopBarbersTotal(state),
    automationId: 'topSalesByBarber',
  };
})(PieChartWithLegend);

export default TopSalesByBarber;
